import { useEffect } from "react";
import { useGetNotificationListQuery } from "services/api/warehouseApi";
import { setNotificationList } from "store/Slices/gridEventSlice";
import { useAppDispatch } from "./StoreHooks";

const EXPIRING_CHECK_INTERVAL_IN_MS = 300000;

export function useGetNotificationList(storeNb: number) {
  const dispatch = useAppDispatch();

  const { isLoading, data: fetchedNotifications } = useGetNotificationListQuery(
    storeNb,
    {
      pollingInterval: EXPIRING_CHECK_INTERVAL_IN_MS,
    }
  );

  useEffect(() => {
    if (fetchedNotifications) {
      dispatch(setNotificationList(fetchedNotifications));
    }
  }, [fetchedNotifications, dispatch]);
  return isLoading;
}
